// IntentTemplatesMenu — I-106: snabb-start-templates för AI-chat.
//
// Nya users möts av en blank textarea. De 6-8 vanligaste use-case:en
// är värda en quick-click så user ser EXEMPEL istället för att stirra
// på paralys-blanketten. Samma pattern som AiDiagramQuickAction, fast
// for workflow-intent.
//
// Templates-katalogen bor i `@/lib/intentTemplates` så fast-refresh-
// reglerna respekteras (komponenter och konstanter separerade).

import { LayoutTemplate, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { INTENT_TEMPLATES, type IntentTemplate } from '@/lib/intentTemplates';

export { INTENT_TEMPLATES };
export type { IntentTemplate };

export interface IntentTemplatesMenuProps {
  onPickTemplate: (template: IntentTemplate) => void;
  disabled?: boolean;
}

export function IntentTemplatesMenu({
  onPickTemplate, disabled,
}: IntentTemplatesMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <button
          type="button"
          data-testid="intent-templates-trigger"
          className="inline-flex items-center gap-1.5 text-xs border rounded-md px-2 py-1 hover:bg-accent disabled:opacity-50"
          title="Snabb-start med template"
        >
          <LayoutTemplate className="w-3.5 h-3.5" />
          <span>Templates</span>
          <ChevronDown className="w-3 h-3 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-72">
        <DropdownMenuLabel className="text-[10px] text-muted-foreground uppercase">
          Snabb-start — klick fyller prompt
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {INTENT_TEMPLATES.map((tpl) => (
          <DropdownMenuItem
            key={tpl.id}
            onClick={() => onPickTemplate(tpl)}
            data-testid={`intent-template-${tpl.id}`}
          >
            <div className="flex-1">
              <div className="font-medium">{tpl.label}</div>
              <div className="text-[10px] text-muted-foreground line-clamp-2">
                {tpl.description}
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
